import { Component } from '@theme/component';

const STORAGE_KEY = 'color-scheme';

/**
 * A custom element that toggles the site between the light and dark color schemes.
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement} button - The toggle button.
 *
 * @extends {Component<Refs>}
 */
class ColorSchemeToggle extends Component {
  requiredRefs = ['button'];

  connectedCallback() {
    super.connectedCallback();
    this.#syncPressedState();
  }

  toggle = () => {
    const isDark = document.body.classList.contains('color-scheme-dark');
    const next = isDark ? 'light' : 'dark';

    document.body.classList.remove('color-scheme-light', 'color-scheme-dark');
    document.body.classList.add('color-scheme-' + next);

    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (error) {
      // no-op: persistence is a nice-to-have, not required for the toggle to work
    }

    this.#syncPressedState();
  };

  #syncPressedState() {
    const isDark = document.body.classList.contains('color-scheme-dark');
    this.refs.button.setAttribute('aria-pressed', String(isDark));
  }
}

if (!customElements.get('color-scheme-toggle')) {
  customElements.define('color-scheme-toggle', ColorSchemeToggle);
}
